import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { setGuestSession } from '../reducers/auth/auth'
import { GuestSession, saveGuestSession } from '../utils/guestSession'
import { requestGuestIdentity } from '../utils/requestGuestIdentity'
import { useSocket } from './useSocket'
import { useSelector } from './useSelector'

/**
 * Start or restore a guest session.
 *
 * `startGuest()` mints a new guest; `startGuest(key)` redeems a play link. Both
 * store the session and put it in redux, which is what makes `useSocket`
 * reconnect carrying the key — from that reconnect on, the guest is an ordinary
 * authenticated player as far as the server is concerned.
 */
export const useGuestSession = () => {
  const socket = useSocket()
  const dispatch = useDispatch()
  const session = useSelector(s => s.auth.guestSession)

  const startGuest = useCallback(async (token?: string): Promise<GuestSession> => {
    const next = await requestGuestIdentity(socket, token)

    saveGuestSession(next)
    dispatch(setGuestSession(next))

    return next
  }, [socket, dispatch])

  return { session, startGuest, ready: !!socket }
}
